
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/pickup/chevrolet-silverado",
      function () {
        return require("private-next-pages/rims/pickup/chevrolet-silverado.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/pickup/chevrolet-silverado"])
      });
    }
  